/**
 * 用户相关接口
 * 接口文档 http://47.110.15.13:8020/pages/viewpage.action?pageId=6291552
 * @type {{login: string}}
 */
const users = {
  // 登录
  login: '/api/Account/LoginToUserAuthenticationPlatform',
  // 注册-手机
  registerWithPhone: '/api/Account/RegisterPhoneUser',
  // 注册-邮箱
  registerWithEmail: '/api/Account/RegisterEmailUser',
  // 验证是否已存在该用户
  isUserExist: '/api/Account/UserExist',
  // 发送验证码
  sendCode: '/api/Account/SendCode',
  // 重置密码
  resetPassword: '/api/Account/ChangePlatformPassword',
  // 使用userToken登录
  tokenLogin: '/api/Account/LoginByUserToken',
}

Object.freeze(users)
export default users
